import React from 'react';
import { useTranslation } from 'react-i18next';

import { Launch } from '@mui/icons-material';

import { LocalizedLink } from '../_shared/LocalizedLink';
// eslint-disable-next-line import/no-webpack-loader-syntax
import logoBhvr from '!file-loader!../_assets/bhvr.svg';
import { LanguageSelector } from './language-selector/LanguageSelector';

export function Header(): JSX.Element {
  const { t } = useTranslation();

  return (
    <header>
      <div className='d-flex align-items-center w-100'>
        <LocalizedLink className='navbar-brand ml-3' to='/'>
          <img src={logoBhvr} width='53' alt={`${t('footer.logo')} Behaviour Interactive`} />
        </LocalizedLink>
        <div className='mr-auto ml-3 logo-account'>
          <div>{t('header.bhvr-account.title1')}</div>
          <div>{t('header.bhvr-account.title2')}</div>
        </div>
      </div>
      <div className='support-container'>
        <a
          id='header-support'
          data-cy='support-page-link'
          href={t('header.nav.support.link')}
          target='_blank'
          className='support-link'
          rel='noopener noreferrer'
        >
          <Launch className='icon' />
          <span className='support-text'>{t('header.nav.support.title')}</span>
        </a>
      </div>
      <LanguageSelector />
    </header>
  );
}
